import { BaseChartAPIProps } from '~/types/create.types';

import {
  recalculateScaleVisibleRange,
  reDraw,
} from '../recalculate/recalculate';

export const zoom = (
  zoomScale: number,
  barSpacing: number,
  base?: BaseChartAPIProps
): number | null => {
  let spacing = barSpacing;
  if (!base) {
    return null;
  }
  const newBarSpacing = spacing + zoomScale * (spacing / 10);
  const maxBarSpacing = base.options.width * 0.5;
  const minBarSpacing = base.x.barSpacing;
  spacing = newBarSpacing;
  if (newBarSpacing > maxBarSpacing) {
    spacing = maxBarSpacing;
  }
  if (newBarSpacing < minBarSpacing) {
    spacing = minBarSpacing;
  }

  if (spacing !== barSpacing) {
    const scale = recalculateScaleVisibleRange(
      base.options,
      base.data,
      base.x,
      spacing
    );
    reDraw({ ...base, x: scale.x, y: scale.y });
  }
  return spacing;
};
